module.exports = __webpack_public_path__ + "assets/images/pdf-feature@2x-0240b532089b7ac3f5b874b1672cc1b8.png";